import {
  AmountFieldSchema,
  ArrayFieldSchema,
  CheckboxGroupFieldSchema,
  DateFieldSchema,
  DynamicFieldSchema,
  FieldSchema,
  FileFieldSchema,
  FileManagementFieldSchema,
  HiddenFieldSchema,
  ObjectFieldSchema,
  RadioBoxFieldSchema,
  ReadOnlyFieldSchema,
  SelectFieldSchema,
  TextAreaFieldSchema,
  TextFieldSchema
} from "../Index";

export function isSelectFieldSchema(schema: FieldSchema): schema is SelectFieldSchema {
  return schema.type === "select";
}

export function isArrayFieldSchema(schema: FieldSchema): schema is ArrayFieldSchema {
  return schema.type === "array";
}

export function isObjectFieldSchema(schema: FieldSchema): schema is ObjectFieldSchema {
  return schema.type === "object";
}

export function isRadioFieldSchema(schema: FieldSchema): schema is RadioBoxFieldSchema {
  return schema.type === "radio";
}

export function isCheckboxGroupFieldSchema(schema: FieldSchema): schema is CheckboxGroupFieldSchema {
  return schema.type === "checkbox-group";
}

export function isFileFieldSchema(schema: FieldSchema): schema is FileFieldSchema {
  return schema.type === "file";
}

export function isFileManagementFieldSchema(schema: FieldSchema): schema is FileManagementFieldSchema {
  return schema.type === "file-management";
}

export function isTextFieldSchema(schema: FieldSchema): schema is TextFieldSchema {
  return schema.type === "text";
}

export function isTextAreaFieldSchema(schema: FieldSchema): schema is TextAreaFieldSchema {
  return schema.type === "textArea";
}

export function isReadonlyFieldSchema(schema: FieldSchema): schema is ReadOnlyFieldSchema {
  return schema.type === "readOnly";
}

export function isDateFieldSchema(schema: FieldSchema): schema is DateFieldSchema {
  return schema.type === "date";
}

export function isAmountFieldSchema(schema: FieldSchema): schema is AmountFieldSchema {
  return schema.type === "amount";
}

export function isHiddenFieldSchema(schema: FieldSchema): schema is HiddenFieldSchema {
  return schema.type === "hidden";
}

export function isDynamicFieldSchema(schema: FieldSchema): schema is DynamicFieldSchema {
  return schema.type === "dynamic";
}